import { Button, Dialog, Grid, Table, TableCell, TableRow, Typography } from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import Theme from "../../../Theme";

export const StyledDialog = styled(Dialog)`
  overflow: hidden;
`;

export const PageGrid = styled(Grid)`
  max-width: 98%;
  margin-left: auto;
  margin-right: auto;
`;

export const ActionGrid = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const CenteredGrid = styled(Grid)`
  text-align: center;
`;

export const NotesGrid = styled(Grid)`
  margin-bottom: 50px;
`;

export const WarningMessage = styled.p`
  font-weight: bold;
  color: red;
`;

export const Setting = styled(Grid)`
  display: flex;
  margin: 0.5em;
  align-items: center;

  & a {
    text-decoration: none;
  }
`;

export const SettingButton = styled(Button)`
  height: 56px;
`;

export const ActionSettingsGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
`;

export const CustomApiGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FieldNameLabels = styled(Typography)`
  font-weight: 700;
`;

export const LongFieldTypography = styled(Typography)`
  max-width: 800px;
`;

export const WarningLabel = styled(Typography)`
  color: red;
`;

export const StyledWarningIcon = styled(Warning)`
  color: red;
`;

export const ObjectTable = styled(Table)`
  padding: 0;
`;

export const FieldTable = styled(Table)`
  padding: 0;
  background-color: ${Theme.colors.lightTable};
`;

export const FieldTableRow = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: ${Theme.colors.lightTableAlt};
  }
`;

export const AddedAccessTableCell = styled(TableCell)`
  background-color: ${Theme.colors.addAccess};
`;

export const RemovedAccessTableCell = styled(TableCell)`
  background-color: ${Theme.colors.removeAccess};
`;
